// extracted by mini-css-extract-plugin
export default {"wrap":"Yp-z","logoContainer":"Zp-z","brandImg":"_p-z","logoImg":"aq-z","logoButton":"bq-z"};